import { useState } from 'react';
import { observer } from 'mobx-react';
import { henshu, useHenshu } from '@strategies/henshu';
import { WatchAnchors } from '@strategies/react-anchors';
import ReactMobilized from '@strategies/react-mobilized';

import './App.scss';

import { COMAP_URL, MENU, MOBILE_BREAKPOINT } from './config';
import Contact from './components/Contact/Contact';
import Process from './components/Process/Process';
import Resources from './components/Resources/Resources';
import Vision from './components/Vision/Vision';
import Welcome from './components/Welcome/Welcome';
import ArrowIcon from './assets/arrow-icon-blue.svg';
import CSULogo from './assets/csu-logo.jpg'
import MSULogo from './assets/msu_logo_white.svg';

import MSUFooterLogo from './assets/msu_logo_white.svg';


export default observer(function App() {
    const [section, setSection] = useState(0);
    const { bindTo } = useHenshu();

    return (
        <div className="App">
            <ReactMobilized
                anchors={MENU}
                logo={<img src={MSULogo} alt="Michigan State University" />}
                banner={<henshu.a href={"#share"} {...bindTo('banner')} />}
                breakpoint={MOBILE_BREAKPOINT}
                section={section + 1}
                setCurrentSection={n => setSection(n - 1)}
            >
                <WatchAnchors
                    onTop={anchor => setSection(anchor.index)}
                    onOffscreen={anchor => !(anchor.top < 0) && setSection(anchor.index - 1)}
                >
                    <Welcome />
                    <Vision />
                    <Process />
                    <Resources />
                    <Contact section={section} />
                </WatchAnchors>

                <footer>
                    <div className="logo">
                        <img src={MSUFooterLogo} alt="Cleveland State University logo" />
                    </div>

                    <button onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}>
                        <img src={ArrowIcon} alt="" />
                    </button>
                </footer>
            </ReactMobilized>
        </div>
    );
});
